import { observable, action } from 'mobx';
import { Dimensions } from 'react-native';
import SizeUtil from '../Utils/SizeUtil';
import { RootStoreInterface } from './index';

export interface SizeInterface {
    deviceWidth: number;
    deviceHeight: number;
    rootStore: RootStoreInterface;
    registryConfigrationChange(): void;
    unregistryConfigrationChange(): void;
    configrationChange(): void;
}
class Size implements SizeInterface {
    @observable
    public deviceWidth = Dimensions.get('window').width;

    @observable
    public deviceHeight = Dimensions.get('window').height;

    public rootStore: RootStoreInterface;

    public constructor(rootStore: RootStoreInterface) {
        this.rootStore = rootStore;
    }

    public registryConfigrationChange = () => {
        Dimensions.addEventListener('change', this.configrationChange);
    };

    public unregistryConfigrationChange = () => {
        Dimensions.removeEventListener('change', this.configrationChange);
    };

    @action
    public configrationChange = () => {
        const { width, height } = Dimensions.get('window');
        this.deviceWidth = width;
        this.deviceHeight = height;

        SizeUtil.updateScreenSize({
            width,
            height
        })
    };
}

export default Size;
